import React, { useEffect } from 'react'
import { Button, notification, Table } from 'antd'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { Route } from 'react-router-dom'

import { fetchAlertsList } from '~actions'
import { ALERT_TYPES } from '~constants'
import { getCurrentUser } from '~context'
import { PageLayout } from '~stories'

import './GlobalAlertList.modules.css'

const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const addNewAlert = (isContentEditor, alerts) => {
  return (
    <Route render={({ history }) => (
      <Button
        key="1"
        disabled={!isContentEditor}
        onClick={() => {
          isContentEditor
            ? history.push('/global-alerts/new')
            : notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
        }}
        type="primary"
      >
        Add New Alert
      </Button>
    )} />
  )
}

const columns = [
  {
    title: 'Venue ID',
    dataIndex: 'venue_id',
    width: '15%',
    key: 'venue_id'
  },
  {
    title: 'Type',
    dataIndex: 'color',
    width: '5%',
    key: 'color',
    render: (text, alert) => {
      const alertType = ALERT_TYPES.find(t => t?.color?.toUpperCase() === alert?.color?.toUpperCase()) || ALERT_TYPES[0]
      return (
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span
            style={{
              display: 'inline-block',
              width: 20,
              height: 20,
              backgroundColor: alertType?.color,
              borderRadius: 4,
              border: '1px solid rgba(0,0,0,0.1)'
            }}
          />
        </span>
      )
    }
  },
  {
    title: 'Message',
    dataIndex: 'message',
    key: 'message',
    width: '50%',
    render: (text, alert) => <a href={`/global-alerts/${alert?._id}/edit`}><div dangerouslySetInnerHTML={{ __html: alert?.message }} /></a>
  }, {
    title: 'Url',
    dataIndex: 'url',
    width: '40%',
    key: 'url'
  }, {
    title: 'Status',
    dataIndex: 'active',
    key: 'active',
    render: (text, alert) => <>{alert?.active ? 'ACTIVE' : 'INACTIVE'}</>
  }]

const GlobalAlertList = ({ fetchAlertsList, alerts }) => {
  const { userDetails: { isContentEditor } } = getCurrentUser()

  useEffect(() => {
    fetchAlertsList()
  }, [fetchAlertsList])

  return (
    <PageLayout extra={[
      addNewAlert(isContentEditor, alerts)
    ]} title="Global Alerts">
      <div className="artists-layout-background">
        <Table bordered columns={columns} dataSource={alerts} pagination={false} />
      </div>
    </PageLayout>
  )
}

GlobalAlertList.propTypes = {
  alerts: PropTypes.array,
  fetchAlertsList: PropTypes.func
}

GlobalAlertList.defaultProps = {
  allVenues: []
}

const mapStateToProps = ({ alerts }) => {
  const { alerts: alertsList } = alerts
  return {
    alerts: alertsList
  }
}

const mapDispatchToProps = {
  fetchAlertsList
}

export default React.memo(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GlobalAlertList)
)
